declare global {
  interface Navigator {
    deviceMemory?: number
    userAgentData?: { platform: string }
  }
}

let cachedFingerprint: string | null = null
let fingerprintEnabled = false

export const setFingerprintEnabled = (value: boolean) => { fingerprintEnabled = value }
export const isFingerprintEnabled = () => fingerprintEnabled

async function sha256 (message: string): Promise<string> {
  const msgBuffer = new TextEncoder().encode(message)
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('')
}

export async function getBrowserFingerprint(): Promise<string> {
  if (cachedFingerprint) return cachedFingerprint

  const components = [
    navigator.userAgent,
    navigator.userAgentData?.platform ?? navigator.platform ?? '',
    Intl.DateTimeFormat().resolvedOptions().timeZone,
  ]

  console.log('fpComp', components)

  cachedFingerprint = await sha256(components.join('|'))
  return cachedFingerprint
}